const setFieldId = "setFieldId";
const setLocation = "setLocation";
const setFeature = "setFeature";
const setZoom = "setZoom";
const setFBILevel = "setFBILevel";
const setIndex = "setIndex";
const setUploadFeature = "setUploadFeature";
const setYear = "setYear";
const setTable = "setTable";
const setCropYear = "setCropYear";
const setSeason = "setSeason";

export {
  setFieldId,
  setLocation,
  setFeature,
  setZoom,
  setFBILevel,
  setIndex,
  setUploadFeature,
  setYear,
  setTable,
  setCropYear,
  setSeason,
};
